import { post } from "../config/api_methods";

export const createStudent = (params) => {
  const response = post("/students", params);
  return response;
};

export default createStudent;
